import ROUTE from '@app/navigationApp/routes';
import { Theme, ThemedPressable, ThemedText, ThemedView } from '@app/theme';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Image, Pressable, StyleSheet, Text, View } from 'react-native';
import ElevateRate from "../../../../assets/Icons/ElevateRate";
import { ThemedTouchableOpacity } from '@app/theme/Components';
import { useTheme } from '@shopify/restyle';
import { trackEvent } from '@app/utils';

const ElevateHomeCard = ({ navigation }) => {

  const { colors } = useTheme<Theme>()

  const navigateToElevateLanding = () => {
    AsyncStorage.setItem('isElevate', "true")
    trackEvent('DSP_NEW_LOAN_BANNER_CHECK_ELIGIBILITY_BUTTON_CLICKED')
    navigation.navigate(ROUTE.ELEVATE_LANDING);

  }

  return (
    <ThemedPressable onPress={navigateToElevateLanding} justifyContent='space-between' flexDirection='row' alignItems='center' borderRadius='lg' backgroundColor="bg-action-primary" overflow='hidden' mx="lg" mt="lg">
      <ThemedView pl="md" pb="2xl" pt="lg" flex={2}>
        <ThemedText textTransform='uppercase' variant='b4r' color="text-on-action-primary" mb="sm">Make a smart move</ThemedText>
        <ThemedText variant='b3b' color="chalk">
          Get faster loans, lower {'\n'}rates, & better services
        </ThemedText>

        <ThemedView bg='bg-fill-primary' borderRadius='full' alignSelf='flex-start' mt='lg' paddingVertical='xs' paddingHorizontal='lg'>
          <ThemedText variant='b4b' color='text-action-primary'>Check eligibility</ThemedText>
        </ThemedView>
      </ThemedView>
      <ThemedView flex={1.2}>
        <ElevateRate shadowColor={colors['border-emphasis-primary']} />
        <ThemedView alignItems='center' overflow='hidden' px='sm' py='xs' mr='md' borderRadius='full' mt='md'>
          <ThemedText color='text-on-action-primary' style={{zIndex: 10}} variant='b5b'>₹0 Processing fee</ThemedText>
          <ThemedView style={[StyleSheet.absoluteFillObject, {opacity: 0.1}]} bg='bg-surface-emphasis-primary' />

        </ThemedView>
      </ThemedView>
      <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/elevate_home_card_mesh.png" }} style={{ width: 120, height: 200, position: "absolute", right: 0 }} />
    </ThemedPressable>
  );
};

export default ElevateHomeCard;


// Todo: Use new theme while revamping
const styles = StyleSheet.create({
  coinImage: {
    height: 95,
    width: 95,
    alignSelf: 'flex-end',
  },
  bgImage: {
    height: '100%',
    width: 120,
    alignSelf: 'flex-end',
    position: 'absolute',
    right: 0,
  },
});
